import React from 'react';
import { FactureOpenSearch } from '@europrocurement/l2d-domain';

import {
    useBilling,
    useDocumentPreviewContext,
} from '@europrocurement/l2d-modules/modules/Dossiers';
import { CircularProgress, MenuItem, Typography } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';

export type MenuPreviewInvoiceType = {
    facture: FactureOpenSearch;
};
const MenuPreviewInvoice: React.FunctionComponent<MenuPreviewInvoiceType> = function ({ facture }) {
    const { previewLoading, setPreviewLoading, setDocumentPreview } = useDocumentPreviewContext();
    const { downloadInvoice } = useBilling({ origine: 'L2DF' });

    const getInvoiceLabel = (): string => {
        if (facture.type && facture.type === 'AVOIR') {
            return `Avoir ${facture.factureNumero}.pdf`;
        }
        return `Facture ${facture.factureNumero}.pdf`;
    };

    const handlePreviewInvoice = async () => {
        if (previewLoading) {
            return;
        }

        if (facture.id) {
            setPreviewLoading(true);
            try {
                const blob = await downloadInvoice(facture.id as number);
                setDocumentPreview({
                    fileName: getInvoiceLabel(),
                    fileType: 'pdf',
                    content: blob as unknown as Blob,
                });
            } catch (error) {
                console.log(error);
            }
            setPreviewLoading(false);
        }
    };

    if (!facture.id) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <></>;
    }

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {previewLoading || !facture.id ? (
                <MenuItem sx={{ gap: '4px' }}>
                    <CircularProgress size="16px" />
                </MenuItem>
            ) : (
                <MenuItem
                    sx={{ gap: '4 px' }}
                    onClick={handlePreviewInvoice}
                >
                    <FaOptionIcon
                        icon={['fasl', 'eye']}
                        color="text.gris70"
                    />
                    <Typography sx={{ color: 'text.primary' }}>Voir la facture</Typography>
                </MenuItem>
            )}
        </>
    );
};

export default MenuPreviewInvoice;
